import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledPopularWidgets = styled.section`
	background-color: ${CSSVars.black};
	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		padding: 75px 30px;
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	.content {
		max-width: 1280px;
		margin: 0 auto;
	}

	h2 {
		color: ${CSSVars.white};
		text-align: center;
		font-family: ${CSSVars.primaryFont};
		font-weight: 600;
		font-size: ${CSSVars.fontSize2XL};
		line-height: 1.2;
		margin: 0 auto 15px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			font-size: ${CSSVars.fontSize4XL};
		}
	}

	.subtitle {
		color: ${CSSVars.white};
		opacity: 0.7;
		text-align: center;
		font-weight: 300;
		font-size: 16px;
		line-height: 24px;
		max-width: 600px;
		margin: 0 auto 40px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			margin-bottom: 50px;
		}
	}

	.widget-search {
		position: relative;
		z-index: 2;
		display: flex;
		align-items: center;
		max-width: 560px;
		margin: -10px auto 40px;
		padding: 6px 6px 6px 16px;
		background-color: rgba(255, 255, 255, 0.06);
		border: 1px solid rgba(255, 255, 255, 0.15);
		border-radius: 999px;
		transition: border-color 0.2s ease, box-shadow 0.2s ease;

		&:focus-within {
			border-color: rgba(76, 79, 255, 0.9);
			box-shadow: 0 0 0 3px rgba(76, 79, 255, 0.25);
		}

		.search-icon {
			flex-shrink: 0;
			color: ${CSSVars.white};
			opacity: 0.6;
			font-size: 22px;
		}

		input {
			flex: 1;
			min-width: 0;
			height: 44px;
			padding: 0 12px;
			background: transparent;
			border: none;
			outline: none;
			color: ${CSSVars.white};
			font-size: 16px;

			&::placeholder {
				color: ${CSSVars.white};
				opacity: 0.45;
			}

			&::-webkit-search-cancel-button {
				filter: grayscale(1) invert(1);
			}
		}

		button {
			flex-shrink: 0;
			height: 44px;
			padding: 0 22px;
			border: none;
			border-radius: 999px;
			background-color: ${CSSVars.blue500};
			color: ${CSSVars.white};
			font-family: ${CSSVars.primaryFont};
			font-weight: 500;
			font-size: 15px;
			cursor: pointer;
			transition: background-color 0.2s ease;

			&:hover {
				background-color: ${CSSVars.blue600};
			}
		}

		.suggestions {
			position: absolute;
			top: calc(100% + 8px);
			left: 0;
			right: 0;
			/* About five rows, then the list scrolls on its own */
			max-height: min(300px, 45vh);
			overflow-y: auto;
			overscroll-behavior: contain;
			list-style: none;
			margin: 0;
			padding: 6px;
			background-color: ${CSSVars.gray950};
			border: 1px solid rgba(255, 255, 255, 0.15);
			border-radius: 16px;
			box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
			text-align: left;

			a {
				display: flex;
				align-items: center;
				gap: 12px;
				padding: 8px 10px;
				border-radius: 10px;
				text-decoration: none;

				&.active {
					background-color: rgba(76, 79, 255, 0.18);
				}

				img {
					flex-shrink: 0;
					border-radius: 6px;
					object-fit: contain;
				}

				span {
					display: flex;
					flex-direction: column;
					min-width: 0;
				}

				strong {
					color: ${CSSVars.white};
					font-weight: 500;
					font-size: 15px;
					line-height: 1.3;
				}

				small {
					color: ${CSSVars.white};
					opacity: 0.5;
					font-size: 12px;
				}
			}
		}

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			margin-bottom: 50px;
		}
	}

	.featured-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 12px;
		list-style: none;
		padding: 0;
		margin: 0 0 45px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			grid-template-columns: repeat(3, 1fr);
			gap: 16px;
		}

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			grid-template-columns: repeat(5, 1fr);
		}
	}

	.widget-card {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		gap: 4px;

		height: 100%;
		padding: 22px 12px 18px;
		background-color: rgba(255, 255, 255, 0.03);
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 16px;
		text-decoration: none;
		transition: border-color 0.2s ease, background-color 0.2s ease,
			transform 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			border-color: rgba(76, 79, 255, 0.8);
			background-color: rgba(76, 79, 255, 0.08);
			transform: translateY(-3px);
			box-shadow: 0 10px 28px rgba(76, 79, 255, 0.18);

			.widget-icon img {
				transform: scale(1.08);
			}
		}

		.widget-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 64px;
			height: 64px;
			margin-bottom: 10px;
			border-radius: 14px;
			background-color: rgba(255, 255, 255, 0.06);

			img {
				width: 44px;
				height: 44px;
				object-fit: contain;
				border-radius: 10px;
				transition: transform 0.2s ease;
			}
		}

		.widget-name {
			color: ${CSSVars.white};
			font-family: ${CSSVars.primaryFont};
			font-weight: 500;
			font-size: 15px;
			line-height: 1.3;
		}

		.widget-category {
			color: ${CSSVars.white};
			opacity: 0.5;
			font-weight: 300;
			font-size: 12px;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.widget-card {
			transition: none;

			&:hover {
				transform: none;

				.widget-icon img {
					transform: none;
				}
			}
		}
	}

	.browse-all {
		display: flex;
		justify-content: center;
	}
`;
